// Single source of truth for task priority/status colors, shared by the Tasks
// list badges and the task-detail header pills. Pill = filled (priority), soft
// tint (status). Dots are the accent used in the status/priority menus.

export const priorityColors: Record<string, string> = {
  urgent: "bg-red-500 text-white",
  high: "bg-orange-500 text-white",
  medium: "bg-yellow-500 text-black",
  low: "bg-green-500 text-white",
};

export const statusColors: Record<string, string> = {
  open: "bg-blue-100 text-blue-800 dark:bg-blue-950/20 dark:text-blue-200",
  submitted: "bg-violet-100 text-violet-800 dark:bg-violet-950/20 dark:text-violet-200",
  in_progress: "bg-purple-100 text-purple-800 dark:bg-purple-950/20 dark:text-purple-200",
  pending_info: "bg-yellow-100 text-yellow-800 dark:bg-yellow-950/20 dark:text-yellow-200",
  resolved: "bg-green-100 text-green-800 dark:bg-green-950/20 dark:text-green-200",
  closed: "bg-gray-100 text-gray-800 dark:bg-gray-950/20 dark:text-gray-200",
};

// Accent dot per value (used in the menu option rows). Plain hex — dots are a
// small color signal, no dark variant needed.
export const priorityDot: Record<string, string> = {
  urgent: "#DC2626",
  high: "#EA580C",
  medium: "#CA8A04",
  low: "#16A34A",
};

export const statusDot: Record<string, string> = {
  open: "#2563EB",
  submitted: "#7C3AED",
  in_progress: "#9333EA",
  pending_info: "#CA8A04",
  resolved: "#16A34A",
  closed: "#6B7280",
};

// Option order + labels for the menus.
export const STATUS_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "open", label: "Open" },
  { value: "submitted", label: "Submitted" },
  { value: "in_progress", label: "In Progress" },
  { value: "pending_info", label: "Pending Info" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
];

export const PRIORITY_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
];

export const formatTaskValueLabel = (v: string) =>
  String(v || "").replace(/_/g, " ").toUpperCase();
